<template>
  <kst-section :title="Info.Section.DebtReminder.Title">
    <kst-input field="DebtDueReminderDays" :data="userData" :catalog="Catalog"/>
    <kst-input field="DebtEmailSentTime" :data="userData" :catalog="Catalog"/>

    <List class="mt-5"
      :userDebtEmailList="userDebtEmailList"
    />

    <template #bottom>
      <kst-button action-mode
        class="is-primary"
        :label="Model.Email.ModuleType.New.Name"
        :moduleType="Model.Email.ModuleType.New"
        @click="handleNew"
      />
    </template>
  </kst-section>
</template>

<script>
import Catalog from "../CpCatalog.js";
import Info from "../CpInfo.js";
import Model from "../CpModel.js";

import List from "./CpE_DebtReminder_List.vue";

export default {
  components: {
    List
  },
  props: {
    userData: Object,
    userDebtEmailList: Array
  },
  data: () => ({
    Catalog: Catalog,
    Info: Info,
    Model: Model
  }),
  methods: {
    handleNew() {
      this.userDebtEmailList.push(
        Model.createEmailDetails()
      );
    }
  }
}
</script>